module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_c('span', [_vm._v("公告管理 / ")]), _vm._v(" "), (_vm.edit === false) ? _c('span', [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.edit !== false) ? _c('span', [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "back",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    ref: "announceForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.announceForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题：",
      "prop": "title"
    }
  }, [_c('el-input', {
    staticClass: "labelWidth",
    attrs: {
      "placeholder": "请输入标题，不超过50个字符"
    },
    model: {
      value: (_vm.announceForm.title),
      callback: function($$v) {
        _vm.$set(_vm.announceForm, "title", $$v)
      },
      expression: "announceForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容：",
      "prop": "content"
    }
  }, [_c('el-input', {
    staticClass: "labelWidth",
    attrs: {
      "type": "textarea",
      "placeholder": "这里填写内容",
      "autosize": {
        minRows: 3
      }
    },
    model: {
      value: (_vm.announceForm.content),
      callback: function($$v) {
        _vm.$set(_vm.announceForm, "content", $$v)
      },
      expression: "announceForm.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "弹框有效期：",
      "prop": "validDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "placeholder": "请选择弹框有效期"
    },
    model: {
      value: (_vm.announceForm.validDate),
      callback: function($$v) {
        _vm.$set(_vm.announceForm, "validDate", $$v)
      },
      expression: "announceForm.validDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传图片：",
      "prop": "imageUrl"
    }
  }, [_c('UploadImage', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/upload/one?uploadImageType=8",
      "urls": _vm.announceForm.imageUrl
    },
    on: {
      "onUrls": _vm.handleSuccess
    }
  })], 1), _vm._v(" "), _c('select-school', {
    attrs: {
      "schObj": _vm.announceForm.schObj,
      "isRoot": _vm.isRoot
    },
    on: {
      "changeVal": _vm.handleSchoolChanged
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.clickSave(1)
      }
    }
  }, [_vm._v("保存为草稿")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.clickSave(2)
      }
    }
  }, [_vm._v("保存并发布")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c4a4c70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UniversityManage/UniversityManage/Announcement/AnnouncementDetail.vue
// module id = 1015
// module chunks = 0